import React from 'react';
import { profileData } from '../data';

const Timeline = ({ field }) => {
  const content = profileData[field] || [];

  return (
    <div className="mx-auto font-sans text-midground">
      {Array.isArray(content) &&
        content.length > 0 &&
        content.map((item, index) => {
          const isLast = index === content.length - 1;

          return (
            <div
              key={index}
              className={`relative ${isLast ? 'pb-0' : 'pb-12'}`}
            >
              {/* Dotted Vertical Line */}
              {!isLast && (
                <div className="absolute left-[6px] top-5 sm:top-6 bottom-0 w-0 border-l-4 border-dotted border-foreground" />
              )}

              <div className="flex items-center mb-2 gap-x-2 md:gap-x-6">
                <div className="z-10 w-4 h-4 border-2 rounded-full border-foreground bg-secondary shrink-0" />
                <p className="text-sm font-semibold tracking-wide text-midground-accent sm:text-base">
                  {item.start_date} - {item.end_date}
                </p>
              </div>

              
                <div className="pl-5 space-y- sm:!pl-10">
                  {field === 'experience' && (
                    <>
                      <div className='flex flex-row items-center justify-between w-full'>
                        <div>
                          <h3 className="text-base font-bold text-midground md:text-xl">
                            {item.title}
                          </h3>
                          <p className="mt-2 text-sm text-midground-accent sm:text-base">
                            {item.company} · {item.city}, {item.country}
                          </p>
                        </div>
                        {/*
                          <div className='flex-row justify-start hidden md:flex gap-x-7'>
                            {item.tags.map(([tag, icon], index) => (
                              <div key={index} className='flex flex-row items-center gap-x-2'>
                                <img src={icon} alt={`${tag} icon`} className="object-contain w-10 h-10" />
                                <span className='text-xs font-semibold sm:text-sm'>{tag}</span>  
                              </div>
                            ))}
                          </div>
                        */}
                      </div>
                      
                      <ul className="pl-4 mt-3 space-y-2 list-disc list-outside">
                        {item.description.map((bullet, bulletIdx) => (
                          <li
                            key={bulletIdx}
                            className="text-sm leading-relaxed text-midground md:text-base"
                          >
                            {bullet}
                          </li>
                        ))}
                      </ul>
                  </>
                  )}
                  {field === 'education' && (
                    <>
                      <h3 className="text-base font-bold text-midground md:text-xl">
                        {item.program}
                      </h3>
                      <p className="text-sm text-midground-accent sm:text-base">
                        {item.degree} · {item.university} · {item.city},{' '}
                        {item.country}
                      </p>
                    </>
                  )}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default Timeline;
